<template>
  <form @submit.prevent="onSubmit">
    <div
      class="md-layout-item md-size-66 md-small-size-100 mx-auto text-center"
      style="margin-bottom:0px"
    >
      <h2 class="title text-primary black" style="margin-top:12px">{{$t('My profile')}}</h2>
    </div>

    <md-card-content v-if="loaded">
      <md-field class="md-form-group">
        <i class="fab fa-linkedin" aria-hidden="true"></i>
        <md-input
          v-model="model.linkedIn"
          placeholder="https://www.linkedin.com/in/profile-identifier/"
        />
      </md-field>

      <md-field class="md-form-group">
        <i class="fab fa-twitter" aria-hidden="true"></i>
        <md-input v-model="model.twitter" placeholder="https://twitter.com/profile-identifier" />
      </md-field>

      <md-switch
        class="md-switch md-theme-default md-primary"
        style="margin-top:20px"
        v-model="model.chatActive"
      >{{$t('Chat active')}}</md-switch>
    </md-card-content>

    <md-card-actions>
      <md-button class="md-button md-round md-primary md-sm" type="submit">{{ $t('Submit') }}</md-button>
    </md-card-actions>
  </form>
</template>

<script>
import axios from "@/util/axios";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      language: "language/current",
      conference: "conference/current"
    })
  },

  data() {
    return {
      loaded: false,
      model: {}
    };
  },
  methods: {
    async loadData() {
      let loader = this.$loading.show({ container: this.$refs.page });

      try {
        this.model = (await axios.get("public/myprofile/settings")).data;
      } finally {
        loader.hide();
        this.loaded = true;
      }
    },
    async onSubmit() {
      let loader = this.$loading.show();

      try {
        let result = await axios.post("public/myprofile/settings", {
          ...this.model
        });
        this.$swal({
          icon: "success",
          text: this.$t("Data saved")
        });
        await this.$store.dispatch("user/refreshProfile");
      } catch (exception) {
        console.log(exception);
      } finally {
        loader.hide();
      }
    }
  },
  mounted() {
    this.loadData();
  }
};
</script>

<style lang="scss" scoped>
.md-fab,
.md-icon-button {
  z-index: 0 !important;
}
.md-icon {
  z-index: 0;
}
</style>
